import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixAcademyCertificationsUserV1UserCertificationsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/user-certifications',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/academy/certifications/v1/user-certifications',
        destPath: '/v1/user-certifications',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/academy/certifications/v1/user-certifications',
        destPath: '/v1/user-certifications',
      },
    ],
    _: [
      {
        srcPath: '/academy/certifications/v1/user-certifications',
        destPath: '/v1/user-certifications',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_user-certifications_user-certifications';

/** Retrieves a user certification. */
export function getUserCertification(
  payload: object
): RequestOptionsFactory<any> {
  function __getUserCertification({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.academy.certifications.v1.user_certification',
      method: 'GET' as any,
      methodFqn:
        'wix.academy.certifications.user.v1.UserCertifications.GetUserCertification',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixAcademyCertificationsUserV1UserCertificationsUrl({
        protoPath: '/v1/user-certifications/{userCertificationId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'userCertification.createdDate' },
              { path: 'userCertification.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getUserCertification;
}
